export default __webpack_public_path__ + "6aca7ecbae34efe3943d2b6ae6c08f4b.png";